/**
 * Componente AttendanceList
 * Gerencia a navegação entre as diferentes visualizações de chamada
 */

import React, { useState, useEffect } from 'react';
import ListCourses from '../../Course/ListCourses/ListCourses'; 
import AttendanceRecords from '../AttendanceRecords/AttendanceRecords'; 
import LessonPlan from '../LessonPlan/LessonPlan'; 
import './AttendanceList.css';

// Importação dinâmica para evitar problemas de import recursivo
const PrintLessonPlansByProfessor = React.lazy(() => import('../LessonPlanByProfessor/PrintLessonPlansByProfessor'));

function AttendanceList({ userType: userTypeProp }) {
  const [activeTab, setActiveTab] = useState('records');
  // Usa o userType vindo da prop
  const userType = userTypeProp;

  /**
   * Se for professor, força a aba de chamadas
   */
  useEffect(() => {
    if (userType === 'professor') {
      setActiveTab('records');
    }
  }, [userType]);

  const handleTabChange = (tab) => {
    if (userType === 'professor' && tab === 'courses') return;
    setActiveTab(tab);
  };

  return (
    <div className="list-containet-tab" style={{ marginTop: window.innerWidth <= 768 ? '60px' : '0' }}>
      <div className="tabs">
        {userType === 'admin' && (
          <button
            className={`tab-button ${activeTab === 'courses' ? 'active' : ''}`}
            onClick={() => handleTabChange('courses')}
          >
            turmas
          </button>
        )}
        <button
          className={`tab-button ${activeTab === 'records' ? 'active' : ''}`}
          onClick={() => handleTabChange('records')}
        >
          Chamadas
        </button>
        <button
          className={`tab-button ${activeTab === 'lessonPlan' ? 'active' : ''}`}
          onClick={() => handleTabChange('lessonPlan')}
        >
          Planejamento
        </button>
        {userType === 'admin' && (
          <button
            className={`tab-button ${activeTab === 'printLessonPlans' ? 'active' : ''}`}
            onClick={() => handleTabChange('printLessonPlans')}
          >
            Imprimir Planejamentos
          </button>
        )}
      </div>

      <div className="tab-content">
        {activeTab === 'courses' && userType === 'admin' && <ListCourses />}
        {activeTab === 'records' && <AttendanceRecords userType={userType} />}
        {activeTab === 'lessonPlan' && <LessonPlan userType={userType} />}
        {activeTab === 'printLessonPlans' && userType === 'admin' && (
          <React.Suspense fallback={<div>Carregando...</div>}>
            <PrintLessonPlansByProfessor />
          </React.Suspense>
        )}
      </div>
    </div>
  );
}

export default AttendanceList;